import React, { useContext, useEffect } from "react";
import { useQuery } from '@apollo/client';
import './Video.scss'
import CartoucheInfos from 'components/CartoucheInfos';
import VideoPlayer from './VideoPlayer';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Suggestion from 'components/Suggestion';
import Utils from 'utils/Utils';
import { SettingsContext } from 'Providers/SettingsProvider';
import Queries from 'utils/Queries';

function Video({id}) {
  const { translate, setTick } = useContext(SettingsContext);
  const { data } = useQuery(Queries.video,{
    variables: { id:parseInt(id) },
  });
  useEffect(()=>setTick(t=>t+1),[data,setTick]);
  const item=data ? data.videos[0] : {};
  const cartoucheDataTop=[
      ...Utils.renderExpos(item),
      {key:'video',value:translate(item,'name')},
      Utils.renderArtistes(item,true),
      {key:'duree',value:item.duree},
  ];
  const cartoucheDataBottom=[
    {text:translate(item,'texte')},
    {ps:translate(item,'ps')},
    Utils.renderTags(item),
  ];
  return (<div className="video">
      <div className="main-container">
          <Grid container>
              <Grid item xs={12} md={3}>
                  {data && <CartoucheInfos data={cartoucheDataTop}/>}
                  {data && <Hidden smDown><CartoucheInfos data={cartoucheDataBottom}/></Hidden>}
              </Grid>
              <Grid item xs={12} md={9}>
                  {item && <VideoPlayer video={item.video}/>}
              </Grid>
              <Grid item xs={12}>
                  {data && <Hidden mdUp><CartoucheInfos data={cartoucheDataBottom}/></Hidden>}
              </Grid>
          </Grid>
          <Suggestion currentItem={item}/>
      </div>
  </div>);
}
export default Video;
